// extracted by mini-css-extract-plugin
module.exports = {"content":"content___IOilt","unsure":"unsure___2Z7S6","unsureCenter":"unsureCenter___2TTa_","button":"button___3MwKX","callUs":"callUs___3EdCx","inPackage":"inPackage___1Gdj3","imgWrapper":"imgWrapper___6KpLu","packageText":"packageText___2KZH1","feedBack":"feedBack___6xXyF","feedHead":"feedHead___bizgU","feedBackItem":"feedBackItem___YKvx4","feedText":"feedText___U3yzD","feedName":"feedName___1lLD8","footer":"footer___DYmvL","everything":"everything___25zDk","create":"create___3QILo","text":"text___3DyOn","needHelp":"needHelp___aePrv"};;
    if (module.hot) {
      var injectCss = function injectCss(prev, href) {
        var link = prev.cloneNode();
        link.href = href;
        link.onload = function() {
          prev.parentNode.removeChild(prev);
        };
        prev.stale = true;
        prev.parentNode.insertBefore(link, prev);
      };
      module.hot.dispose(function() {
        window.__webpack_reload_css__ = true;
      });
      if (window.__webpack_reload_css__) {
        module.hot.__webpack_reload_css__ = false;
        console.log("[HMR] Reloading stylesheets...");
        var prefix = document.location.protocol + '//' + document.location.host;
        document
          .querySelectorAll("link[href][rel=stylesheet]")
          .forEach(function(link) {
            if (!link.href.match(prefix) || link.stale) return;
            injectCss(link, link.href.split("?")[0] + "?unix=1793768668872");
          });
      }
    }
  